import { NotificationHeader } from './notification-popover-content-header.tsx';
import { NotificationBody } from './notification-popover-content-body.tsx';
import { NotificationFooter } from './notification-popover-content-footer.tsx';
import { useGetNotificationsQuery } from '@/features/notifications/hooks/queries/get-all-notifications.ts';
import { useNotificationsStore } from '@/services/store/use-notifications-store.ts';

export const NotificationContent = () => {
  const notificationFilter = useNotificationsStore((state) => state.notificationFilter);
  const { data, isLoading } = useGetNotificationsQuery({ notificationFilter });

  return (
    <>
      <NotificationHeader />
      <NotificationBody />
      {(Boolean(data?.pages?.length) || isLoading) && <NotificationFooter />}
    </>
  );
};
